import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'start',
    pathMatch: 'full'
  },
  {
    path: 'start',
    loadChildren: () => import('./pages/start/start.module').then(m => m.StartPageModule)
  },
  {
    path: 'stammdaten',
    loadChildren: () => import('./pages/stammdaten/stammdaten.module').then(m => m.StammdatenPageModule),
    canActivate: [AuthGuardService]
  },


  {
    path: 'stammdaten_praxis',
    loadChildren: () => import('./pages/stammdaten_praxis/stammdaten_praxis.module').then(m => m.StammdatenPraxisPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'erfassung_pverm',
    loadChildren: () => import('./pages/erfassung_pverm/erfassung_pverm.module').then(m => m.erfassung_pvermPageModule),
    canActivate: [AuthGuardService]
  },
  
  {
    path: 'praxisvermittlungkauf',
    loadChildren: () => import('./pages/erfassung_pkauf/erfassung_pkauf.module').then(m => m.erfassung_pkaufPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'praxisvermittlungverkauf',
    loadChildren: () => import('./pages/erfassung_pverkauf/erfassung_pverkauf.module').then(m => m.erfassung_pverkaufPageModule),
    canActivate: [AuthGuardService]
  },

  {
    path: 'honorar_beratung',
    loadChildren: () => import('./pages/honorar_beratung/honorar_beratung.module').then(m => m.honorar_beratungPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'honorar_marketing',
    loadChildren: () => import('./pages/honorar_marketing/honorar_marketing.module').then(m => m.honorar_marketingPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'honorar_gruendung',
    loadChildren: () => import('./pages/honorar_gruendung/honorar_gruendung.module').then(m => m.honorar_gruendungPageModule),
    canActivate: [AuthGuardService]
  },






  {
    path: 'umfang',
    loadChildren: () => import('./pages/umfang/umfang.module').then(m => m.UmfangPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'bestandsaufnahme',
    loadChildren: () => import('./pages/bestandsaufnahme/bestandsaufnahme.module').then(m => m.BestandsaufnahmePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'datenschutz',
    loadChildren: () => import('./pages/datenschutz/datenschutz.module').then(m => m.DatenschutzPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'zusammenfassung',
    loadChildren: () => import('./pages/zusammenfassung/zusammenfassung.module').then(m => m.ZusammenfassungPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'einwilligung',
    loadChildren: () => import('./pages/einwilligung/einwilligung.module').then(m => m.EinwilligungPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'unterschrift',
    loadChildren: () => import('./pages/unterschrift/unterschrift.module').then(m => m.UnterschriftPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'impressum',
    loadChildren: () => import('./pages/impressum/impressum.module').then( m => m.ImpressumPageModule)
  },
  {
    path: '**',
    redirectTo: 'start'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
